import { Provider } from "react-redux";
import "./index.scss";
import store, { persistor } from "./store/configure-store";
import Game from "./Game";
import { PersistGate } from "redux-persist/integration/react";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
          <Game />
      </PersistGate>
    </Provider>
  );
}

export default App;
